import { render, staticRenderFns } from "./EmbeddedTest.vue?vue&type=template&id=551079e2"
import script from "./EmbeddedTest.vue?vue&type=script&lang=js"
export * from "./EmbeddedTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports